export default __webpack_public_path__ + "static/image1-5ac4e1d1cf0038aec1cc024f41c86902.jpg";